import { TextField as _TextField, TextFieldProps, InputAdornment, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {getValueFromNestedObject} from "../../../../utils/langUtils.ts";
import Clear from "@mui/icons-material/Clear";

const TextField = styled(_TextField)`
    padding: 0.4rem 0.7rem;
`;

type FormInputProps = {
    name: string;
    label: string;
    clearable?: boolean;
    onValueChange: (text: any) => void;
    forceNumber: boolean;
    checkNumber: boolean;
} & TextFieldProps;

const FormInput: FC<FormInputProps> = ({ name,
                                         label,
                                         clearable = false,
                                         onValueChange = (text) => {},
                                         forceNumber = false,
                                         checkNumber = false,
                                         ...otherProps }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const error = getValueFromNestedObject(errors, name)

    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { value, onChange, onBlur } }) => (
                <TextField
                    fullWidth={true}
                    margin="normal"
                    error={!!error}
                    variant="standard"
                    label={label}
                    value={value ? '' + value : ''}
                    onBlur={onBlur}
                    onChange={(e) => {
                        const text = e.target.value;
                        if (text && checkNumber) {
                            let value = Number(text)
                            if (isNaN(value)) {
                                onValueChange && onValueChange(value)
                                onChange(text)
                            } else if (forceNumber) {
                                onValueChange && onValueChange(value)
                                onChange(value)
                            } else {
                                onValueChange && onValueChange(text)
                                onChange(text)
                            }
                        } else if (text) {
                            onValueChange && onValueChange(text)
                            onChange(text)
                        } else {
                            onValueChange && onValueChange(null)
                            onChange(null)
                        }
                    }}
                    slotProps={ clearable && value ? 
                        {
                            input: {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => onChange('')}
                                            edge="end"
                                        >
                                            <Clear />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            },
                        } 
                        : 
                        {} 
                    }
                    helperText={
                        error ? (error?.message as unknown as string) : ''
                    }
                    {...otherProps}
                />
            )}
        />
    );
};

export default FormInput;
